import { NavigationData } from '../types/navigation';

export const navigationData: NavigationData = {
  global: {
    brand: "Modernize",
    items: [
      { label: "For Homeowners", href: "/homeowners" },
      { label: "For Pros", href: "/pros" },
      { label: "About Modernize", href: "/about" }
    ],
    cta: [
      { label: "Get Quote", href: "/quote", primary: false },
      { label: "Get Leads", href: "/leads", primary: true }
    ]
  },
  subBrands: [
    { name: "Leads", icon: "users", href: "/pros/leads" },
    { name: "Calls", icon: "phone", href: "/pros/calls" },
    { name: "Branded Programs", icon: "star", href: "/pros/programs" },
    { name: "360 Finance", icon: "credit-card", href: "/pros/finance" },
    { name: "Agency", icon: "building", href: "/pros/agency", comingSoon: true }
  ],
  products: {
    finance: {
      title: "360 Finance",
      items: [
        { label: "Overview", href: "/pros/finance" },
        { label: "Features", href: "/pros/finance/features" },
        { label: "Pricing", href: "/pros/finance/pricing" },
        { label: "Applicant Login", href: "/applicant-login", external: true },
        { label: "Contractor Login", href: "/contractor-login", external: true }
      ]
    },
    leads: {
      title: "Lead Generation",
      items: [
        { label: "Overview", href: "/pros/leads" },
        { label: "Branded Leads", href: "/pros/leads/branded" },
        { label: "Live Transfer", href: "/pros/leads/live-transfer" },
        { label: "Qualified Leads", href: "/pros/leads/qualified" },
        { label: "Pricing", href: "/pros/leads/pricing" }
      ]
    },
    calls: {
      title: "Call Services",
      items: [
        { label: "Overview", href: "/pros/calls" },
        { label: "Inbound Calls", href: "/pros/calls/inbound" },
        { label: "Live Transfer", href: "/pros/calls/live-transfer" },
        { label: "Pricing", href: "/pros/calls/pricing" }
      ]
    },
    programs: {
      title: "Branded Programs",
      items: [
        { label: "Overview", href: "/pros/programs" },
        { label: "Program Benefits", href: "/pros/programs/benefits" },
        { label: "Getting Started", href: "/pros/programs/getting-started" },
        { label: "Pricing", href: "/pros/programs/pricing" }
      ]
    }
  }
};